import script from "./odd-man-out.vue?vue&type=script&setup=true&lang=ts"
export * from "./odd-man-out.vue?vue&type=script&setup=true&lang=ts"

import "./odd-man-out.vue?vue&type=style&index=0&id=0124d255&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Cloud Strife\\Desktop\\kronoku-repaint\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0124d255"]])

export default __exports__